import * as React from 'react';
import {RULE_TYPES} from '../../qualifier_rule_data';
import {QualifierRulesSlide} from './QualifierRulesSlide';
import styles from './RulesTabs.module.css';
import Button from '../../../../../components/button/Button';
import {Tab} from '../../../../../components/tabs/Tab';
import {useTabs} from '../../../../../components/tabs/TabsProvider';


export const QualifierRulesTabs: React.FC = (props) => {
    const {changeTab} = useTabs();

    const handleChangeTab = (tab: string) => (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        changeTab(tab);
    }

    return (
        <div className={styles.rulesSectionContainer}>
            <div className={styles.tabsHeader}>
                {RULE_TYPES.map((section, index) => (
                    <Button key={section.value} onClick={handleChangeTab(section.value)}>{section.title}</Button>
                ))}
            </div>
            <div className={styles.tabsContent}>
                {RULE_TYPES.map((section, index) => (
                    <Tab key={section.value} value={section.value} className={styles.tabContent}>
                        {section.slides.map((slide) => (<QualifierRulesSlide key={slide.title} data={slide} />))}
                    </Tab>
                ))}
            </div>
        </div>
    );
};
